import LocalConstants from "app/LocalConstants";
import i18n from "i18n";
import { makeAutoObservable, runInAction } from "mobx";
import moment from "moment"
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import uuid from "uuid";
import {
  pagingAdministratives
} from "../../AdministrativeUnit/AdministrativeUnitService";
import {
  getPatientRegimen,
  getRegimen
} from "../../Regimen/RegimenService";
import {
  createEtbEncounter, deleteEncounter, getEtbEncounter
} from "../Services/EncounterService";
import {
  checkDuplicationPatient,
  checkExist,
  countByAdministrativeUnit,
  countStatusPatient,
  createEtbPatient,
  createEtbPatientEncounter,
  createPatient,
  deletePatient,
  editEtbPatient,
  editPatient,
  getEtbAll,
  getListHistoryEncounter,
  getPageEtbPatientManager,
  getPagePatient, getPagePatientManagementUnit,
  getPatient,
  patientManagement,
  pendingTestList,
  examinateList,
  getPagePatientMoveInOrOut,
  exportCurrentPatientList,
  pagingNotificationPatients,
  incompletePatientAdsm,
  exportManagementUnitList,
  exportPatientIndexList,
  acceptPatientFromOther,
  notAcceptPatientFromOther
} from "../Services/PatientService";
import {
  confirmTransferEtb,
  patientTransferOutByEncounter
} from "../Services/PatientTransferService";
import {
  patientManagementNotificationPatient
} from "../../Notification/NotificationPatientService";
import {
  getLabTestWaitingResult,
  getEtbServiceItemObsHiv,
} from "../../LabTestWaitingResult/LabTestWaitingResultService";
import localStorageService from "app/services/localStorageService";
import lodash from "lodash";
import { getDefaultOrg } from "app/common/CommonFunctions";

const searchObjectInitialValue = {
  gender: "",
  keyword: "",
  patientType: 3,
  registerType: null,
  idNumber: "",
  nationality: null,
  profession: null,
  religion: null,
  ethnics: null,
  org: null,
  currentRegion: null,
  currentProvince: null,
  currentDistrict: null,
  currentWard: null,
  patientTransfer: null,
  typeOfPatient: null,
  patientName: "",
  phoneNumber: null,
  medicalInsurance: null,
  fromAge: '',
  toAge: '',
  codeBnql: null,
  currentUnit: null,
  transferStatus: null,
  sortByDateEncounterDesc: null,
  fromDate: null,
  toDate: null,
  watchBy: null,
  patientCode: null,
  registerNo: null,
  medication: null,
  bacterialEvidence: null,
  sortByRegisterDate: null, //order by theo ngày đăng ký điều trị
  sortByPatientCode: null, //order by theo mã BNQL
  sortByPatientName: null, //order by theo tên BN
  provinceAddress: null,
  districtAddress: null, //huyện theo địa chỉ
  wardAddress: null, //xã theo địa chỉ
}

export default class PatientStore {
  patientList = [];
  regionList = [];
  rootOrgList = [];
  selectedPatient = null;
  selectedEpisodeOfCare = null;
  selectedRegimen = null;
  selectedPatientRegimen = null;
  listEpisodeOfCare = [];
  preCareEncounters = [];
  lastestEpisodeOfCare = null;
  lastEncounter = null;
  selectedPatientList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  openConfirmEncounterDelete = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  showFilterSearch = false;
  listMedicationItems = [];
  notificationDetail = null;
  listNotificationDetail = [];
  notificationDetailOrgTo = null;
  searchObjectInitialValue = { ...searchObjectInitialValue }
  searchObject = { ...searchObjectInitialValue };
  encounterInitialValue = {
    id: "",
    appointmentDto: null,
    encounterDate: null,
    startDate: null,
    endDate: null,
    encounterType: null,
    indexNumber: null,
    isLatestEncounter: false,
    treatmentPeriodDto: null,
    encounterCareType: null,
    encounterStage: null,
    orgEncounter: null,
    provider: null,
    patient: null,
    medicationRequests: [],
    listSymptoms: [],
    listDiagnosis: [],
    listLabTests: [],
    listImagingStudys: [],
  };
  listLabTests = [];
  selectedLabTest = null;
  listImagingStudys = [];
  selectedImagingStudy = null;
  sumPatient = 0;
  patientTransferredTo = 0;
  untreatedPatient = 0;
  patientPageInfo = {
    beingTreated: null,
    // transfer: null,
    transferIn: null,
    transferOut: null,
    endOfProfile: null,
    administrativeUnits: [],
    moveInNotAccept: null,
  };

  defaulHistoryEncounterList = [];
  historyEncounterList = [];
  episodeOfCareList = [];
  viewEpisodeOfCareList = [];
  currentEncounter = null;
  listProvinces = [];
  listProvincesForward = [];
  countEpisodeOfCare = 0;
  listMonthTreatment = [];
  countEncounter = 0;
  countRelatedPerson = 0;
  treatmentTabValue = 0;
  encounterEditable = false;
  etbRole = {};
  //biến kiểm tra đã nhập xét nghiệm chưa
  //(chỉ check khi thêm mới lần khám)
  isLabTestChange = false;

  //check trùng bn có phân trang
  duplicatePatientPage = {};
  duplicateSearchObject = {
    pageIndex: 1,
    pageSize: 5
  };

  //biến đơn vị theo ds theo đơn vị
  currentUnitOrg = {}
  //key để phân biệt thuốc trong phác đồ
  medicationEditKey = null;
  //cảnh báo khi phác đồ có yêu cầu nhập thuốc nhóm gì đấy
  noteCalculateRegimen = "";
  //hiển thị chi tiết cảnh báo
  shouldOpenNotificationPopup = false;
  //biến thay đổi mỗi khi save lần khám, tiếp nhận bn
  countSaveEncounter = 0;
  //hiển thị popup xét nghiệm từ cảnh báo
  shouldOpenNotificationLabTestResultPopup = false;
  selectedNotificationLabTestResult = null;
  detailNotificationEncounterId = null;
  currentPatientNotificationId = null;
  //value chuyển tab trong EncounterForm
  encounterTabValue = 0;
  //hiển thị popup adsm từ cảnh báo
  shouldOpenAdsmResultPopup = false;
  selectedNotificationADSM = null;
  //hiển thị tiếp nhận bệnh nhân từ cảnh báo
  shouldOpenNotificationConfirmTransferPopup = false;
  selectedNotificationConfirmTransferItem = null;
  //ngày xét nghiệm M2 khi thêm mới xn -> để mặc định ngày xn cho những xn thêm sau
  defaultM2LabTestDate = null;
  defaultM2LabTestDateName = null;
  //biến timeout ở tìm kiếm ds bệnh nhân, sau 5p tự động xóa các trường tìm kiếm
  patientListSearchTimeout = null;
  //ds thẻ nhắc trong chi tiết bệnh nhân
  patientReminderCardList = [];
  //kiểm tra có cần call lại api check loại kháng thuốc không
  shouldCheckTypeResistance = false;
  //check có là ds dot thuốc không
  isDotsThuoc = false;
  //mở popup danh sách trùng lặp
  openDuplicationPatientPopup = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  //hàm timeout ở tìm kiếm ds bệnh nhân, sau 5p tự động xóa các trường tìm kiếm
  handleTimeoutPatientListSearch = () => {
    this.patientListSearchTimeout = setTimeout(() => {
      this.searchObject = { ...searchObjectInitialValue }
      this.page = 1
      this.rowsPerPage = 10
      this.updatePageData();
    }, 300000)

  }

  updatePageData = () => {
    if (this.patientListSearchTimeout) {
      clearTimeout(this.patientListSearchTimeout)
    }

    this.getPagePatient(this.getNewSearchObject());

  };

  updatePageDataEtb = () => {
    this.loadingInitial = true;
    let newSearchObj = this.getNewSearchObject()
    try {
      // let res = await etbPatientManager(newSearchObj);
      this.getPagePatient(newSearchObj);
      this.countStatusPatient(newSearchObj);
      // this.countByAdministrativeUnit(newSearchObj);
      // runInAction(() => {
      //   this.patientList = res.data?.patients.content;
      //   this.totalElements = res.data?.patients.totalElements;
      //   this.totalPages = res.data?.patients.totalPages;
      //   this.patientPageInfo = {
      //     beingTreated: res.data?.beingTreated,
      //     transferIn: res.data?.transferIn,
      //     transferOut: res.data?.transferOut,
      //     endOfProfile: res.data?.endOfProfile,
      //     administrativeUnits: res.data?.administrativeUnits,
      //     moveInNotAccept: res.data?.moveInNotAccept
      //   }
      // });

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  }

  updatePageDataManagementUnit = () => {
    this.loadingInitial = true;
    let newSearchObj = this.getNewSearchObject()

    try {
      getPagePatientManagementUnit(newSearchObj).then((res) => {
        // console.log( 'data from patient list management', res)

        runInAction(() => {
          this.patientList = res.data?.content;
          this.totalElements = res.data?.totalElements;
          this.totalPages = res.data?.totalPages;

        });
      }).catch(error => {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
        this.setLoadingInitial(false);
      })

      this.setLoadingInitial(false);

    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);

    }
  };

  setPagePatientManagementUnit = (page) => {
    this.page = page;
    this.updatePageDataManagementUnit();
  };

  setRowsPerPagePatientManagementUnit = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageDataManagementUnit();
  };

  handleExportManagementUnitList = () => {
    let newSearchObj = this.getNewSearchObject()

    exportManagementUnitList({
      ...newSearchObj,
      pageIndex: undefined,
      pageSize: undefined
    }).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "DANH-SACH-BENH-NHAN-THEO-DON-VI-QUAN-LY" + ".xlsx");
      document.body.appendChild(link);
      link.click();
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    })
  }

  handleChangePagePatientManagementUnit = (event, newPage) => {
    this.setPagePatientManagementUnit(newPage);
  };

  countStatusPatient = (newSearchObj) => {
    countStatusPatient({
      ...newSearchObj,
      year: new Date().getFullYear()
    }).then((res) => {
      runInAction(() => {
        this.patientPageInfo = {
          ...this.patientPageInfo,
          ...res?.data,
        }
      });
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    })
  }

  countByAdministrativeUnit = (newSearchObj) => {
    countByAdministrativeUnit(newSearchObj).then((res) => {
      runInAction(() => {
        // this.patientList = res.data?.patients.content;
        // this.totalElements = res.data?.patients.totalElements;
        // this.totalPages = res.data?.patients.totalPages;
        this.patientPageInfo = {
          ...this.patientPageInfo,
          // beingTreated: res.data?.beingTreated,
          // transferIn: res.data?.transferIn,
          // transferOut: res.data?.transferOut,
          // endOfProfile: res.data?.endOfProfile,
          // moveInNotAccept: res.data?.moveInNotAccept
          administrativeUnits: res.data?.administrativeUnits,
        }
      });
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    })
  }

  getPagePatient = (newSearchObj) => {
    getPagePatient(newSearchObj).then((res) => {
      runInAction(() => {
        // console.log( 'data from patient list', res)
        this.patientList = res.data?.patients.content;
        this.totalElements = res.data?.patients.totalElements;
        this.totalPages = res.data?.patients.totalPages;
        // this.patientPageInfo = {
        //   ...this.patientPageInfo,
        //   beingTreated: res.data?.beingTreated,
        //   transferIn: res.data?.transferIn,
        //   transferOut: res.data?.transferOut,
        //   endOfProfile: res.data?.endOfProfile,
        //   moveInNotAccept: res.data?.moveInNotAccept,
        //   administrativeUnits: res.data?.administrativeUnits,
        // }
      });
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    })
  }

  getRegion = async () => {
    this.loadingInitial = true;
    try {
      let response = await patientManagement({});
      runInAction(() => {
        // this.regionList = response.data;
        this.regionList = response.data.administrativeUnits;
        this.rootOrgList = response.data.organizations;
      });

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  }
  getAdminitractive = async (administrativeUnitId) => {
    try {
      let response = await patientManagement({ administrativeUnitId: administrativeUnitId });
      this.setLoadingInitial(false);
      return response.data;

    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  }

  handleSearchFilter = () => {
    this.showFilterSearch = !this.showFilterSearch;
  };
  handleSetSearchObject = (item) => {

    // if (item) {
    if (item.pageIndex) {
      this.page = item.pageIndex;
      //this.rowsPerPage = item.pageSize
    }
    this.searchObject = { ...item };
    // } else {
    //   this.searchObject = this.initSearchObject;
    // }

    // console.log(this.searchObject)
  }

  pagingEtbPatientManager = async () => {
    this.loadingInitial = true;
    let newSearchObj = this.getNewSearchObject()

    try {
      let data = await getPageEtbPatientManager(newSearchObj);
      runInAction(() => {
        this.patientList = data.data.content;
        this.totalElements = data.data.totalElements;
        this.totalPages = data.data.totalPages;
      });

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
    this.handleTimeoutPatientListSearch()
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
    this.handleTimeoutPatientListSearch()
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditPatient = (id) => {
    this.getPatient(id).then(() => {
      runInAction(() => {
        this.shouldOpenEditorDialog = true;
      });
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.showFilterSearch = false;
    this.shouldOpenNotificationPopup = false;
    this.updatePageDataEtb();
  };

  setShouldOpenConfirmationDialog = state => {
    this.shouldOpenConfirmationDialog = state;
  }

  handleDelete = (id) => {
    this.getPatient(id).then(({ data }) => {
      runInAction(() => {
        this.shouldOpenConfirmationDialog = true;
      })
    });
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleConfirmDelete = () => {
    this.deletePatient(this.selectedPatient.id);
  };

  handleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedPatientList.length; i++) {
      try {
        await deletePatient(this.selectedPatientList[i].id);
      } catch (error) {
        listAlert.push(this.selectedPatientList[i].name);
        console.log(error);
        console.log(listAlert.toString());
        toast.warning(i18n.t("toast.error"));
      }
    }
    this.handleClose();
    toast.success(i18n.t("toast.delete_success"));
  };

  handleSelectPatient = (patient) => {
    if (
      patient &&
      patient.episodeOfCares &&
      patient.episodeOfCares.length > 0
    ) {
      patient.episodeOfCares = patient.episodeOfCares.map((e) => {
        return {
          ...e,
          registerDate: e.registerDate ? new Date(e.registerDate) : null,
        };
      });
    }
    this.selectedPatient = patient;
  };

  handleSelectListPatient = (patients) => {
    this.selectedPatientList = patients;
  };

  getPatient = async (id) => {
    this.loadingInitial = true;
    if (id != null) {
      try {
        let data = await getPatient(id);
        this.handleSelectPatient(data.data);

        this.setLoadingInitial(false);
        return this.selectedPatient;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));

        this.setLoadingInitial(false);
      }
    } else {
      this.handleSelectPatient(null);

      this.setLoadingInitial(false);
    }
  };

  createPatient = async (patient) => {
    try {
      let check = await checkExist(patient);
      if (check.data) {
        toast.warning(i18n.t("toast.duplicate_patient"));
      }
      let response = await createPatient(patient);
      toast.success(i18n.t("toast.add_success"));
      this.handleClose();
      return response.data;

    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.add_fail"));
    }
  };

  editPatient = async (patient) => {
    try {
      let check = await checkExist(patient);
      if (check.data) {
        toast.warning(i18n.t("toast.duplicate_patient"));

      }
      await editPatient(patient);
      toast.success(i18n.t("toast.update_success"));
      this.handleClose();

    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  };

  deletePatient = async (id) => {
    try {
      const res = await deletePatient(id);
      if (res?.data?.code == "-1") {
        toast.warn(i18n.t("toast.delete_fail"));
      } else if (res?.data?.code == "-2") {
        toast.warn(i18n.t("toast.delete_patient_other_org"));
      } else {
        toast.success(i18n.t("toast.delete_success"));
      }
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }
  };

  //------------------------
  //new Etb api

  handleSelectEtb = (data) => {
    this.selectedPatient = data?.patientDto;
    this.defaulHistoryEncounterList = this.historyEncounterList = data?.historyEncounterList || [];
    this.countEncounter = data?.countEncounter || 0;
    // this.handleSelectEncounter(data?.currentEncounter)
    this.currentEncounter = data?.currentEncounter;
    if (this.currentEncounter?.medicationRequests?.length > 0) {
      this.listMedicationItems = this.currentEncounter.medicationRequests[0]?.medicationRequestItems
    } else {
      this.listMedicationItems = [];
    }
    this.countEpisodeOfCare = data?.countEpisodeOfCare || 0;
    this.countRelatedPerson = data?.countRelatedPerson || 0;

    this.viewEpisodeOfCareList = data?.episodeOfCareList || [];
    //chỉ cho phép các đợt của lao kháng thuốc
    // const { org } = getDefaultOrg();
    // const listEtbEpisodeOfCare = data?.episodeOfCareList?.filter((item) => {
    //   return item?.patientType === LocalConstants.PATIENT_TYPE_DRUG_RESISTANT_TB && (!org || item?.organization?.id === org.id)
    // })
    this.episodeOfCareList = data?.episodeOfCareList || [];
    // this.getEpisodeOfCareListByPatientId(data?.patientDto?.id);

    //quyển thêm sửa
    this.etbRole = data?.role;
  };

  // getEpisodeOfCareListByPatientId = async (patientId) => {
  //   if (patientId?.length > 0) {
  //     try {
  //       let res = await getListEpisodeOfCareBy({ patientId });
  //       runInAction(() => {
  //         this.episodeOfCareList = res.data;
  //       })
  //       return res;
  //     } catch (error) {
  //       console.log(error);
  //       // toast.warning("toast.get_fail");
  //     }
  //   } else {
  //     this.episodeOfCareList = []
  //   }
  // }

  getEtbAll = async (obj) => {
    this.loadingInitial = true;
    if (obj?.patientId != null) {
      try {
        let res = await getEtbAll(obj);
        this.handleSelectEtb(res.data);
        this.setLoadingInitial(false);
        return res;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));

        this.setLoadingInitial(false);
      }
    } else {
      this.handleSelectPatient(null);

      this.setLoadingInitial(false);
    }
  };

  createEtbPatient = async (patient) => {
    try {
      // let check = await checkExist(patient);
      // if (check.data) {
      //   toast.warning("Bệnh nhân đã bị trùng!");
      // }
      let response = await createEtbPatient(patient);
      toast.success(i18n.t("toast.enterExaminationInformation"));
      this.selectedPatient = response.data;
      return this.selectedPatient;
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.add_fail"));
    }
  };

  editEtbPatient = async (patient) => {
    try {
      // let check = await checkExist(patient);
      // if (check.data) {
      //   toast.warning("bệnh nhân đã bị trùng!");

      // }
      let response = await editEtbPatient(patient);
      toast.success(i18n.t("toast.update_success"));
      this.selectedPatient = response.data;
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  };

  handleChangeEpisodeOfCare = async (episodeOfCare) => {
    this.selectedEpisodeOfCare = episodeOfCare;
    if (episodeOfCare?.id) {
      try {
        let res = await getListHistoryEncounter(episodeOfCare.id);
        this.historyEncounterList = res.data;
      } catch (error) {
        toast.warning(i18n.t("toast.update_fail"));
      }
    } else {
      this.historyEncounterList = this.defaulHistoryEncounterList;
    }

  };

  handleSelectEncounter = async (encounter) => {
    if (encounter?.id) {
      let res = await getEtbEncounter(encounter.id);
      runInAction(() => {
        this.currentEncounter = res.data;
        if (this.currentEncounter.medicationRequests?.length > 0) {
          this.listMedicationItems = this.currentEncounter.medicationRequests[0]?.medicationRequestItems
        } else {
          this.listMedicationItems = [];
        }
      })
    } else {
      runInAction(() => {
        this.currentEncounter = null;
        this.listMedicationItems = [];
        this.selectedRegimen = null;
        this.isLabTestChange = false;
        this.shouldCheckTypeResistance = false;
      })
    }
    //khi đổi lần khám thì set lại = ""
    this.setNoteCalculateRegimen("")
  }

  setCurrentEncounter = (encounter) => {
    this.currentEncounter = encounter
    this.handleSelectListMedicationItems(this.currentEncounter?.medicationRequests?.[0]?.medicationRequestItems || [])
  }

  createEtbEncounter = async (encounter) => {
    try {
      let res = await createEtbEncounter(encounter);
      toast.success(i18n.t("toast.update_success"));
      this.getEtbAllTypeEncounter()
      this.updateCountSaveEncounter()
      setTimeout(() => {
        localStorageService.removeItem(LocalConstants.LOCAL_STORAGE_CREATE_ENCOUNTER_KEY)
      }, 1000)
      //ghi nhớ lại đơn vị trong xn tổng quát, nếu có
      this.handleMemoUnitOtherTest(encounter)
      return res;
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        localStorageService.setItem(
          LocalConstants.LOCAL_STORAGE_CREATE_ENCOUNTER_KEY,
          JSON.stringify({
            ...encounter,
            userId: localStorageService.getLoginUser()?.id,
            patientId: this.selectedPatient?.id
          })
        )
      }, 1000)
      toast.warning(i18n.t("toast.update_fail"));
    }
  }

  editEtbEncounter = async (encounter) => {
    try {
      // hàm create và edit dùng chung api
      let res = await createEtbEncounter(encounter);
      toast.success(i18n.t("toast.update_success"));
      //dùng để lấy lại currentEncounter = encounter vừa sửa
      this.getEtbAllTypeEncounterByCurrentEncounterId(encounter?.id);
      this.updateCountSaveEncounter()
      //ghi nhớ lại đơn vị trong xn tổng quát, nếu có
      this.handleMemoUnitOtherTest(encounter)
      return res;
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  }

  getProvincesByUserLogin = async () => {
    try {
      let res = await pagingAdministratives({
        pageIndex: 1,
        pageSize: 1000,
        level: 3,
        isGetUserLogin: true
      });
      runInAction(() => {
        this.listProvinces = res.data?.content || [];
      })
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }
  }
  getProvincesForward = async () => {
    try {
      let res = await pagingAdministratives({
        pageIndex: 1,
        pageSize: 1000,
        level: 3,
        isGetUserLogin: false
      });
      runInAction(() => {
        this.listProvincesForward = res.data?.content || [];
      })
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }
  }

  createNewEtbEncounter = async () => {
    this.handleSelectEncounter(null)

    //reset lại ngày lấy mẫu xn mặc định
    this.setDefaultM2LabTestDate(null, null);
    // this.currentEncounter = null;
    // try {
    //   let res = await createNewEtbEncounter(this.selectedPatient?.id);
    //   this.currentEncounter = res.data;
    // } catch (error) {
    //   console.log(error);
    //   toast.warning("Có lỗi xảy ra khi cập nhật!");
    // }
  }

  //phac do dieu tri

  handleSelectRegimen = (regimen) => {
    this.selectedRegimen = regimen;
  };

  handleSelectPatientRegimen = (patientRegimen) => {
    this.selectedPatientRegimen = patientRegimen;
    if (patientRegimen) {
      this.selectedRegimen = patientRegimen.regimen;
    }
  };
  handleEditRegimen = (id) => {
    this.getRegimen(id).then(() => {
      // this.shouldOpenEditorDialog = true;
    });
  };

  getPatientRegimen = async (id) => {
    if (id != null) {
      try {
        let res = await getPatientRegimen(id);
        this.handleSelectPatientRegimen(res.data)
        return this.selectedPatientRegimen;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectPatientRegimen(null);
    }
  };

  getRegimen = async (id) => {
    // console.log(id)
    if (id != null) {
      try {
        let res = await getRegimen(id);
        this.handleSelectRegimen(res.data);
        return this.selectedRegimen;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectRegimen(null);
    }
  };

  handleChangeRegimen = async (regimen) => {
    await this.getRegimen(regimen?.id);
  }

  //MedicationItems
  handleSelectMedicationItem = (item) => {
    this.selectedMedicationItem = item;
  };

  handleCalculateMedicationRequestsByPatientRegimenDate = (field, value, medicationRequests) => {
    if (field === "startDate") {
      let newList = medicationRequests?.[0]?.medicationRequestItems || []
      newList = newList.reduce((acc, item) => {
        //nếu ngày bắt đầu phác đồ bằng ngày bắt đầu của thuốc thì cập nhật ngày bắt đầu của 
        //thuốc theo ngày bắt đầu phác đồ
        if (this.isSameDate(new Date(item?.startDate), new Date(value))) {
          let newItem = { ...item, startDate: value }
          return [...acc, newItem]
        }

        return [...acc, item];
      }, [])
      return [{ medicationRequestItems: newList }];
    } else {
      // debugger
      let newList = medicationRequests?.[0]?.medicationRequestItems
      newList = medicationRequests?.[0]?.medicationRequestItems.reduce((acc, item) => {
        if (this.isSameDate(new Date(item?.endDate), new Date(value))) {
          let newItem = { ...item, endDate: value }
          return [...acc, newItem]
        }

        return [...acc, item];
      }, [])
      return [{ medicationRequestItems: newList }];
    }
  }

  sortedMedicationsByStartDate = list => {
    return list?.sort((a, b) => {
      return new Date(a?.startDate) - new Date(b?.startDate)
    });
  }

  getYesterday = d => {
    let date = new Date(d);
    return date.setDate(date.getDate() - 1)
  }

  getTomorrow = d => {
    let date = new Date(d);
    return date.setDate(date.getDate() + 1)
  }

  isSameDate = (fDate, tDate) => {
    return (
      fDate.getFullYear() === tDate.getFullYear() &&
      fDate.getMonth() === tDate.getMonth() &&
      fDate.getDate() === tDate.getDate()
    );
  }

  updateListMedicationItems = (list, medicationItem) => {
    let listSameMedications = list?.filter(item => item?.medication?.id === this.selectedMedicationItem.medication.id) || [];
    let listOther = list?.filter(item => item.medication?.id !== this.selectedMedicationItem.medication.id) || [];

    listSameMedications = listSameMedications.reduce((acc, item) => {
      //nếu item trong khoảng của thuốc sửa thì xoá luôn item
      // debugger
      // console.log(item.medicationEditKey);
      // console.log(item.medicationEditKey === this.medicationEditKey);
      if (item.medicationEditKey === this.medicationEditKey) {
        let newList = [];
        //nếu ngày bắt đầu cũ trước ngày bắt đầu mới thì tách làm 2
        if ((new Date(medicationItem?.startDate) - new Date(item?.startDate)) > 0) {
          newList.push({ ...item, startDate: item?.startDate, endDate: this.getYesterday(medicationItem?.startDate) })
        }
        newList.push(medicationItem)
        //nếu ngày kết thúc cũ sau ngày kết thúc mới thì tách làm 2
        if ((new Date(medicationItem?.endDate) - new Date(item?.endDate)) < 0) {
          newList.push({ ...item, startDate: this.getTomorrow(medicationItem?.endDate), endDate: item?.endDate })
        }
        return [...acc, ...newList];
      }
      //nếu thuốc sửa thời gian bao ngoài hết item thì xoá item
      if (((new Date(item?.startDate) - new Date(medicationItem?.startDate)) >= 0)
        && ((new Date(item?.endDate) - new Date(medicationItem?.startDate)) >= 0)
        && ((new Date(item?.endDate) - new Date(medicationItem?.endDate)) <= 0)) {
        return acc;
      }
      //nếu ngày bắt đầu của thuốc sửa trong khoảng item thì lùi ngày kết thúc của item
      if (((new Date(item?.startDate) - new Date(medicationItem?.startDate)) <= 0)
        && ((new Date(item?.endDate) - new Date(medicationItem?.startDate)) >= 0)) {
        let newItem = { ...item, endDate: this.getYesterday(medicationItem?.startDate) }
        return [...acc, newItem]
      }
      //nếu ngày kết thúc của thuốc sửa trong khoảng của item thì lùi ngày bắt đầu của item
      if (((new Date(medicationItem?.endDate) - new Date(item?.startDate)) >= 0)
        && ((new Date(medicationItem?.endDate) - new Date(item?.endDate)) <= 0)) {
        let newItem = { ...item, startDate: this.getTomorrow(medicationItem?.endDate) }
        return [...acc, newItem]
      }
      return [...acc, item];
    }, [])
    this.sortedMedicationsByStartDate(listSameMedications);

    return listOther.concat(listSameMedications);
  }

  addNewToListMedicationItems = (list, medicationItem) => {
    let listSameMedications = list?.filter(item => item?.medication?.id === medicationItem.medication.id) || [];
    const medicationEditKey = uuid.v4();
    listSameMedications.push({ ...medicationItem, medicationEditKey });
    // this.medicationEditKey = medicationEditKey;
    let listOther = list?.filter(item => item.medication?.id !== medicationItem.medication.id) || [];

    listSameMedications = listSameMedications.reduce((acc, item) => {
      //nếu thuốc thêm bao gồm hết item thì xoá luôn item
      if (((new Date(item?.startDate) - new Date(medicationItem?.startDate)) >= 0)
        && ((new Date(item?.endDate) - new Date(medicationItem?.startDate)) >= 0)
        && ((new Date(item?.endDate) - new Date(medicationItem?.endDate)) <= 0)
        && medicationEditKey != item?.medicationEditKey) {
        return acc;
      }
      //nếu thuốc thêm nhảy vào giữa 1 thuốc đang có thì tách làm 3
      if (((new Date(item?.startDate) - new Date(medicationItem?.startDate)) <= 0)
        // && ((new Date(item?.endDate) - new Date(medicationItem?.startDate)) > 0)
        // && ((new Date(medicationItem?.endDate) - new Date(item?.startDate)) > 0)
        && ((new Date(medicationItem?.endDate) - new Date(item?.endDate)) <= 0)
        && medicationEditKey != item?.medicationEditKey) {
        let newList = [];
        if (((new Date(item?.startDate) - new Date(medicationItem?.startDate)) < 0)) {
          let newItem1 = { ...item, endDate: this.getYesterday(medicationItem?.startDate) }
          newList.push(newItem1)
        }
        // newList.push(medicationItem)
        if (((new Date(medicationItem?.endDate) - new Date(item?.endDate)) < 0)) {
          let newItem2 = { ...item, startDate: this.getTomorrow(medicationItem?.endDate) }
          newList.push(newItem2)
        }
        return [...acc, ...newList]
      }
      //nếu ngày bắt đầu của thuốc thêm trong khoảng item thì lùi ngày kết thúc của item
      if (((new Date(item?.startDate) - new Date(medicationItem?.startDate)) <= 0)
        && ((new Date(item?.endDate) - new Date(medicationItem?.startDate)) >= 0)
        && medicationEditKey != item?.medicationEditKey) {
        let newItem = { ...item, endDate: this.getYesterday(medicationItem?.startDate) }
        return [...acc, newItem]
      }
      //nếu ngày kết thúc của thuốc thêm trong khoảng của item thì lùi ngày bắt đầu của item
      if (((new Date(medicationItem?.endDate) - new Date(item?.startDate)) >= 0)
        && ((new Date(medicationItem?.endDate) - new Date(item?.endDate)) <= 0)
        && medicationEditKey != item?.medicationEditKey) {
        let newItem = { ...item, startDate: this.getTomorrow(medicationItem?.endDate) }
        return [...acc, newItem]
      }
      return [...acc, item];
    }, [])
    this.sortedMedicationsByStartDate(listSameMedications);

    return listOther.concat(listSameMedications);
  }

  handleUpdateListMedicationItems = (medicationItem, update) => {
    let list = this.listMedicationItems;
    if (medicationItem) {
      if (this.selectedMedicationItem) {
        //sửa
        list = this.updateListMedicationItems(list, medicationItem);
        // list = list.map((item) => {
        //   if (item.medication?.id === this.selectedMedicationItem.medication.id
        //     && item.medicationEditKey === this.medicationEditKey) {
        //     return medicationItem;
        //   }
        //   return item;
        // })
      } else {
        //thêm mới
        if (!list) {
          list = [];
        }
        // list.push(medicationItem);
        list = this.addNewToListMedicationItems(list, medicationItem);
      }
    } else {
      toast.warning(i18n.t("toast.notEnterData"))
    }
    this.handleSelectListMedicationItems(list);
    update(list);
  };

  handleSelectListMedicationItems = (list) => {
    this.listMedicationItems = list;
  }

  handleDeleteMedicationItem = (medicationItem, update) => {
    let list = [];
    if (this.listMedicationItems?.length > 0) {
      this.listMedicationItems.forEach((item) => {
        if (item.medicationEditKey && item.medicationEditKey === this.medicationEditKey) {
          return
        }
        list.push(item)
      })
    }
    this.handleSelectListMedicationItems(list)
    update(list);
  }


  handleConfimDeleteEncounter = () => {
    deleteEncounter(this.currentEncounter.id).then(({ data }) => {
      toast.success(i18n.t("toast.delete_success"));
      this.getEtbAllTypeEncounter()
      //để update lại list lần khám
      this.updateCountSaveEncounter()
    }).catch(() => {
      toast.warning(i18n.t("toast.error"));
    })
  }

  confirmTransferEtb = async (patientTransfer) => {
    try {
      let res = await confirmTransferEtb(patientTransfer);
      this.handleSelectEncounter(res.data);
      this.updateCountSaveEncounter()
      this.getEtbAllTypeEncounter()
      // .finally(() => {
      //   this.setEncounterEditable(true)
      // })
      this.setDefaultM2LabTestDate(null, null);
      if (res?.data?.code === "-1") {
        toast.warn(i18n.t("toast.receivedByOther"));
        return res;
      }
      toast.success(i18n.t("toast.successReceived"));
      return res;
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }
  }

  getEtbAllTypeEncounter = async () => {
    await this.getEtbAll({
      patientId: this.selectedPatient?.id,
      typeBook: LocalConstants.TypeBook?.[0]?.value,
    });
  }
  getEtbAllTypeRelatePerson = async () => {
    await this.getEtbAll({
      patientId: this.selectedPatient?.id,
      typeBook: LocalConstants.TypeBook?.[2]?.value,
    });
  }

  getEtbAllTypeEncounterByCurrentEncounterId = (currentEncounterId) => {
    this.getEtbAll({
      patientId: this.selectedPatient?.id,
      typeBook: LocalConstants.TypeBook?.[0]?.value,
      currentEncounterId: currentEncounterId,
    });
  }

  setListMonthTreatment = (list) => {
    this.listMonthTreatment = list;
  }

  handleSetCount = (etbDto) => {
    this.countEncounter = etbDto?.countEncounter || 0;
    this.countEpisodeOfCare = etbDto?.countEpisodeOfCare || 0;
    this.countRelatedPerson = etbDto?.countRelatedPerson || 0;
  }

  setTreatmentTabValue = (value) => {
    this.treatmentTabValue = value;
  }

  setEncounterEditable = (value) => {
    this.encounterEditable = value;
  }

  createEtbPatientEncounter = async (obj) => {
    try {
      let response = await createEtbPatientEncounter(obj);
      toast.success(i18n.t("toast.add_success"));
      this.selectedPatient = response.data;
      setTimeout(() => {
        localStorageService.removeItem(LocalConstants.LOCAL_STORAGE_CREATE_PATIENT_KEY)
      }, 1000)
      //ghi nhớ lại đơn vị trong xn tổng quát, nếu có
      this.handleMemoUnitOtherTest(obj?.encounter)
      return this.selectedPatient;
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        localStorageService.setItem(
          LocalConstants.LOCAL_STORAGE_CREATE_PATIENT_KEY,
          JSON.stringify({
            ...obj,
            userId: localStorageService.getLoginUser()?.id
          })
        )
      }, 1000)
      toast.warning(i18n.t("toast.add_fail"));
    }
  }

  //dùng cho thêm mới thông tin bn và lần khám
  resetPatientEncounter = () => {
    this.selectedPatient = null;
    this.defaulHistoryEncounterList = this.historyEncounterList = [];
    this.countEncounter = 0;
    this.viewEpisodeOfCareList = [];
    this.episodeOfCareList = [];
    this.handleSelectEncounter(null)
    this.countEpisodeOfCare = 0;
    this.listMedicationItems = [];
    this.selectedRegimen = null;
    this.setNoteCalculateRegimen("");
    this.setDefaultM2LabTestDate(null, null);
    this.shouldCheckTypeResistance = false;
  }

  setLabTestChange = (value) => {
    this.isLabTestChange = value;
  }

  //hàm kiểm tra trùng lặp thông tin bệnh nhân
  checkDuplicationPatient = (obj) => {
    this.duplicateSearchObject = {
      ...this.duplicateSearchObject,
      id: obj?.id,
      patientName: obj.displayName,
      birthDate: obj.birthDate,
      gender: obj.gender,
      idNumber: obj.idNumber,
      idCitizen: obj.idCitizen,
      medicalIdentifier: obj.medicalIdentifier,
      phoneNumber: obj.phoneNumber,
      medicalInsurance: obj.medicalInsurance,
      provinceId: obj?.currentProvince?.id,
      districtId: obj?.currentDistrict?.id,
      wardId: obj?.currentWard?.id
    };
    return this.pagingDuplicationPatient();
  }

  handleCheckDuplicationPatient = (values) => {
    if (!values?.patient?.displayName?.trim()) {
      toast.warn(i18n.t("validation.enterFullName"));
      return
    }
    this.checkDuplicationPatient(values?.patient).then(data => {
      if (data.content?.length > 0) {
        this.setOpenDuplicationPatientPopup(true)
      }
    })
  }


  handleChangeSearchObjectDuplicate = (name, value) => {
    this.duplicateSearchObject[name] = value;
    this.pagingDuplicationPatient()
  }

  pagingDuplicationPatient = async () => {
    try {
      let response = await checkDuplicationPatient({ ...this.duplicateSearchObject });
      this.updateDuplicatePagingData(response.data)
      // if (response.data.content?.length === 0) {
      //   toast.success(i18n.t("toast.notDuplicatePatient"))
      // }
      return response.data;
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }
  }

  updateDuplicatePagingData = (data) => {
    this.duplicatePatientPage = data;
  }

  setCurrentUnitOrg = (value) => {
    this.currentUnitOrg = value;
  }

  //danh sách bệnh nhận chưa nhập kết quả có trạng thái là chờ kết quả
  updatePagePendingTestList = async (keyword) => {
    this.loadingInitial = true;
    let newSearchObj = this.getNewSearchObject()
    if (keyword == 'examinate') {
      try {
        let res = await examinateList(newSearchObj);
        runInAction(() => {
          this.patientList = res.data?.content;
          this.totalElements = res.data?.totalElements;
          this.totalPages = res.data?.totalPages;
        });

        this.setLoadingInitial(false);
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
        this.setLoadingInitial(false);
      }
      return
    }
    try {
      let res = await pendingTestList(newSearchObj);
      runInAction(() => {
        this.patientList = res.data?.content;
        this.totalElements = res.data?.totalElements;
        this.totalPages = res.data?.totalPages;
      });

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  }

  setMedicationEditKey = (key) => {
    this.medicationEditKey = key;
  }
  /*chuyển trang cho danh sách bệnh nhận chờ kết quả*/
  setRowsPerPagePending = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageDataPatientFromNotification();
  };
  setPagePending = (page) => {
    this.page = page;
    this.updatePageDataPatientFromNotification();
  };
  handleChangePagePending = (event, newPage) => {
    this.setPagePending(newPage);
  };

  /*chuyển trang cho danh sách chuyển đến/chuyển đi */
  setRowsPerPageTransfer = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.getPagePatientMoveInOrOut();
  };
  setPageTransfer = (page) => {
    this.page = page;
    this.getPagePatientMoveInOrOut();
  };
  handleChangePageTransfer = (event, newPage) => {
    this.setPageTransfer(newPage);
  };

  setNoteCalculateRegimen = (value) => {
    this.noteCalculateRegimen = value;
  }

  //hàm dùng cho xét nghiệm
  handleBeforeSubmitLabTest = (values) => {
    let labTestItem = { ...values };

    //gộp lại vào biến sampleDate từ 3 biến giờ, phút, ngày
    // if (values?.sampleDate) {
    //   labTestItem = this.handleMergeSampleDate(labTestItem)
    // }
    //nếu là mtb thì hiện k có mtb
    if (labTestItem?.requestForm?.isMTB &&
      labTestItem?.diagnosticReport?.mtb == LocalConstants.ListMTBResistant?.[1]?.value
    ) {
      labTestItem.diagnosticReport.reportResult = LocalConstants.ListMTBResistant?.[1]?.name
      labTestItem.diagnosticReport.itemObss = null;
    } else {
      //itemObss không có value thì xoá đi
      if (labTestItem?.diagnosticReport?.itemObss?.length > 0) {
        labTestItem = this.handleUpdateDiagnosticReport(labTestItem);
      }
      //nếu vẫn còn itemObss thì tính stringResult
      if (labTestItem?.diagnosticReport?.itemObss?.length > 0) {
        labTestItem = this.handleSetStringResult(labTestItem);
      } else {
        if (labTestItem?.requestForm?.isMTB && labTestItem?.diagnosticReport?.mtb) {
          const mtbText = [...LocalConstants.ListMTBResistant, { value: "3", name: "Lỗi" }]
            ?.find(e => e.value == labTestItem?.diagnosticReport?.mtb)?.name;
          labTestItem.diagnosticReport.reportResult = mtbText;
        } else {
          labTestItem.diagnosticReport.reportResult = "";
        }
      }
    }

    // console.log(labTestItem);
    return {
      ...labTestItem,
      formName: labTestItem?.formName?.trim(),
      specimenTypeOther: labTestItem?.specimenTypeOther?.trim(),
      reasonSecondTime: labTestItem?.reasonSecondTime?.trim(),
      orgTestOther: labTestItem?.orgTestOther?.trim(),
      requester: labTestItem?.requester?.trim(),
      diagnosticReport: {
        ...labTestItem?.diagnosticReport,
        reportCode: labTestItem?.diagnosticReport?.reportCode?.trim(),
        patientStatusOther: labTestItem?.diagnosticReport?.patientStatusOther?.trim(),
      }
    };
  }
  // handleMergeSampleDate = (labTestItem) => {
  //   if (Number.isInteger(Number(labTestItem?.sampleHour))
  //     && Number.isInteger(Number(labTestItem?.sampleMinute))
  //     && moment(labTestItem?.sampleDate).isValid()) {
  //     return {
  //       ...labTestItem,
  //       sampleDate: new Date(`${labTestItem.sampleHour}:${labTestItem.sampleMinute} ${moment(labTestItem?.sampleDate).format("MM/DD/YYYY")}`)
  //     }
  //   } else {
  //     return labTestItem;
  //   }
  // }
  handleUpdateDiagnosticReport = (labTestItem) => {
    let newItemObss = labTestItem.diagnosticReport.itemObss.reduce((acc, itemObs) => {
      if (itemObs?.subItemObservations?.length > 0) {
        const newSubItemObs = itemObs?.subItemObservations.reduce((subAcc, subItemObs) => {
          if (subItemObs?.valueCoded) {
            return [
              ...subAcc,
              {
                ...subItemObs,
                comments: subItemObs?.comments?.trim(),
              }
            ]
          } else {
            return subAcc
          }
        }, [])
        if (newSubItemObs.length > 0) {
          return [
            ...acc,
            {
              ...itemObs,
              comments: itemObs?.comments?.trim(),
              subItemObservations: newSubItemObs
            }
          ]
        } else {
          return acc;
        }
      } else {
        // debugger
        if (!itemObs?.item) {
          return acc
        }

        // nếu là thuốc thêm thì chỉ cần item
        if (itemObs?.isAddConcept) {
          // nếu là thuốc khác thì chỉ cần tên thuốc là được, k cần phải xóa theo value
          if (itemObs?.item?.name?.trim()?.toLocaleUpperCase() === "THUỐC KHÁC"
            && itemObs?.detailTestName?.trim()) {
            return [
              ...acc,
              {
                ...itemObs,
                valueText: itemObs?.valueText?.trim(),
                detailTestName: itemObs?.detailTestName?.trim(),
                comments: itemObs?.comments?.trim(),
              }
            ]

          }
          return [
            ...acc,
            {
              ...itemObs,
              valueText: itemObs?.valueText?.trim(),
              detailTestName: itemObs?.detailTestName?.trim(),
              comments: itemObs?.comments?.trim(),
            }
          ]

        }

        //nếu chưa nhập value hoặc xoá value thì xoá itemObs
        switch (itemObs?.item?.datatype) {
          case LocalConstants.DATATYPE_NUMERIC: {
            if (!Number.isNaN(Number.parseFloat(itemObs?.valueNumeric))) {
              return [
                ...acc,
                {
                  ...itemObs,
                  comments: itemObs?.comments?.trim(),
                }
              ]
            } else {
              return acc
            }
          }
          case LocalConstants.DATATYPE_DATE: {
            if (itemObs?.valueDate) {
              return [
                ...acc,
                {
                  ...itemObs,
                  comments: itemObs?.comments?.trim(),
                }
              ]
            } else {
              return acc
            }
          }
          case LocalConstants.DATATYPE_BOOLEAN: {
            if (this.isBoolean(itemObs?.valueBoolean)) {
              return [
                ...acc,
                {
                  ...itemObs,
                  comments: itemObs?.comments?.trim(),
                }
              ]
            } else {
              return acc
            }
          }
          case LocalConstants.DATATYPE_CODED: {
            if (itemObs?.valueCoded) {
              return [
                ...acc,
                {
                  ...itemObs,
                  comments: itemObs?.comments?.trim(),
                }
              ]
            } else {
              return acc
            }
          }
          default: {
            if (itemObs?.valueText) {
              return [
                ...acc,
                {
                  ...itemObs,
                  comments: itemObs?.comments?.trim(),
                }
              ]
            } else {
              return acc
            }
          }
        }
      }
    }, [])
    //nếu itemObss = 0 và khác requestFormMtb thì xoá luôn diagnosticReport
    //update k xoá diagnosticReport nữa chỉ xoá itemObs thôi
    // debugger
    // if (newItemObss?.length === 0 && !labTestItem?.requestForm?.isMTB) {
    //   // setFieldValue(`${name}.diagnosticReport`, null)
    //   return {...labTestItem, diagnosticReport: null}
    // } else {
    // setFieldValue(`${name}.diagnosticReport.itemObss`, newItemObss)
    return {
      ...labTestItem,
      diagnosticReport: {
        ...labTestItem.diagnosticReport,
        itemObss: newItemObss?.length > 0 ? newItemObss : null,
        //gộp giờ, phút vào 1 biến
        // receivedDate: this.handleMergeReceivedDate(labTestItem.diagnosticReport),
        // testDate: this.handleMergeTestDate(labTestItem.diagnosticReport)
      }
    }
    // }
  }

  // handleMergeReceivedDate = (diagnosticReport) => {
  //   if (Number.isInteger(Number(diagnosticReport?.receivedHour))
  //     && Number.isInteger(Number(diagnosticReport?.receivedMinute))
  //     && moment(diagnosticReport?.receivedDate).isValid()) {
  //     return new Date(`${diagnosticReport.receivedHour}:${diagnosticReport.receivedMinute} ${moment(diagnosticReport?.receivedDate).format("MM/DD/YYYY")}`)
  //   } else {
  //     return diagnosticReport?.receivedDate;
  //   }
  // }

  // handleMergeTestDate = (diagnosticReport) => {
  //   if (Number.isInteger(Number(diagnosticReport?.testHour))
  //     && Number.isInteger(Number(diagnosticReport?.testMinute))
  //     && moment(diagnosticReport?.testDate).isValid()) {
  //     return new Date(`${diagnosticReport.testHour}:${diagnosticReport.testMinute} ${moment(diagnosticReport?.testDate).format("MM/DD/YYYY")}`)
  //   } else {
  //     return diagnosticReport?.testDate;
  //   }
  // }

  handleSetStringResult = (labTestItem) => {
    let stringResult = "";
    //số kết quả của xét nghiệm: nếu chỉ 1 xn thì chỉ hiển thị kết quả thôi k cần tên xn
    let countItemObss = labTestItem.diagnosticReport.itemObss.length;
    let newLabTestItem = { ...labTestItem };
    labTestItem.diagnosticReport.itemObss.forEach((itemObs, itemObsIndex) => {
      // debugger
      if (itemObs?.subItemObservations?.length > 0) {
        let newMaxItem = null;
        itemObs.subItemObservations.forEach((sub) => {
          for (let i = 0; i < labTestItem?.sampleNumber; i++) {
            let subItemObservation = itemObs?.subItemObservations?.find((e, index) => i === index);
            if (!newMaxItem || newMaxItem?.viewIndex < subItemObservation?.viewIndex) {
              newMaxItem = subItemObservation;
            }
          }
        })
        //kiểm tra nếu có 2 kết quả số lượng afb ít trở lên
        // console.log(newMaxItem);
        if (newMaxItem?.valueCoded?.datatype === LocalConstants.DATATYPE_NUMERIC
          || newMaxItem?.valueCoded?.datatype === LocalConstants.DATATYPE_TEXT) {
          let listValueLessAFB =
            itemObs?.subItemObservations?.filter((sub) => sub?.valueCoded?.datatype === LocalConstants.DATATYPE_NUMERIC)
          if (listValueLessAFB?.length > 1) {
            let max = 0;
            listValueLessAFB.forEach((e) => {
              if (Number(e?.comments) > Number(max)) {
                max = e.comments
                newMaxItem = e;
              }
            })
          }
        }
        if (countItemObss === 1) {
          stringResult += `${newMaxItem?.valueCoded?.name || ""}`
          //nếu nhập số lượng afb ít thì hiện ra kết quả
          // console.log(newMaxItem);
          if ((newMaxItem?.valueCoded?.datatype === LocalConstants.DATATYPE_NUMERIC
            || newMaxItem?.valueCoded?.datatype === LocalConstants.DATATYPE_TEXT)
            && newMaxItem?.comments) {
            stringResult += ` (${newMaxItem?.comments})`
            //set vào thằng cha
            // setFieldValue(`${name}.diagnosticReport.itemObss.[${itemObsIndex}].comments`, newMaxItem.comments)
            newLabTestItem.diagnosticReport.itemObss[itemObsIndex].comments = newMaxItem.comments
          }
        } else {
          stringResult += `${labTestItem?.requestForm?.concepts?.[itemObsIndex]?.concept?.name}: ${newMaxItem?.valueCoded?.name}`
        }
      } else {
        if (countItemObss === 1) {
          // 
        } else {
          stringResult += `${itemObs?.item?.name}: `;
        }
        // console.log(itemObs);
        if (itemObs?.item?.datatype) {
          switch (itemObs.item.datatype) {
            case LocalConstants.DATATYPE_NUMERIC: {
              stringResult += itemObs?.valueNumeric || "";
              break;
            }
            case LocalConstants.DATATYPE_DATE: {
              stringResult += itemObs?.valueDate ? moment(itemObs?.valueDate).format("DD/MM/YYYY") : "";
              break;
            }
            case LocalConstants.DATATYPE_BOOLEAN: {
              if (itemObs?.valueBoolean === true) {
                stringResult += "Có"
              }
              if (itemObs?.valueBoolean === false) {
                stringResult += "Không"
              }
              break;
            }
            case LocalConstants.DATATYPE_CODED: {
              stringResult += itemObs?.valueCoded?.name || "";
              break;
            }
            default: {
              stringResult += itemObs?.valueText || "";
              break;
            }
          }
        }
        if (itemObs?.comments) {
          stringResult += ` (${itemObs?.comments})`
        }
      }
      stringResult += "; "
    })
    stringResult = stringResult.slice(0, -2) + "";
    // setFieldValue(`${name}.diagnosticReport.reportResult`, stringResult)
    newLabTestItem.diagnosticReport.reportResult = stringResult;
    return newLabTestItem;
  }
  isBoolean = val => 'boolean' === typeof val;

  sortSelectedLabTestRequestType = (requestTypes) => {
    let newRequestTypes = requestTypes?.map(item => {
      let newListLabTests = item?.listLabTests?.map(labTest => {
        return this.sortSelectedLabTest(labTest);
      })
      return {
        ...item,
        listLabTests: newListLabTests,
      }
    })
    return newRequestTypes;
  }

  sortSelectedLabTest = (item) => {
    if (item?.selected) {
      return {
        ...item,
        //gán giờ, phút, nếu chỉ 1 ký tự thì thêm "0"
        hourSampleDate: item?.hourSampleDate?.toString()?.length === 1 ?
          ("0" + item?.hourSampleDate) : (item?.hourSampleDate || ""),
        minuteSampleDate: item?.minuteSampleDate?.toString()?.length === 1 ?
          ("0" + item?.minuteSampleDate) : (item?.minuteSampleDate || ""),
        requestForm: {
          ...item?.requestForm,
          //sắp xếp theo tên các mã XN
          concepts: this.sortConceptsByViewIndex(item?.requestForm?.concepts?.slice())
          // this.sortConceptsByName(item?.requestForm?.concepts, "concept")
        },
        diagnosticReport: {
          ...item?.diagnosticReport,
          //gán giờ, phút, nếu chỉ 1 ký tự thì thêm "0"
          hourReceivedDate: item?.diagnosticReport?.hourReceivedDate?.toString()?.length === 1 ?
            ("0" + item?.diagnosticReport?.hourReceivedDate) :
            (item?.diagnosticReport?.hourReceivedDate || ""),
          minuteReceivedDate: item?.diagnosticReport?.minuteReceivedDate?.toString()?.length === 1 ?
            ("0" + item?.diagnosticReport?.minuteReceivedDate) :
            (item?.diagnosticReport?.minuteReceivedDate || ""),
          hourTestDate: item?.diagnosticReport?.hourTestDate?.toString()?.length === 1 ?
            ("0" + item?.diagnosticReport?.hourTestDate) :
            (item?.diagnosticReport?.hourTestDate || ""),
          minuteTestDate: item?.diagnosticReport?.minuteTestDate?.toString()?.length === 1 ?
            ("0" + item?.diagnosticReport?.minuteTestDate) :
            (item?.diagnosticReport?.minuteTestDate || ""),
          //làm cho 2 array bằng nhau
          itemObss: this.getItemObsFromRequestFormConcepts(item?.requestForm,
            item?.diagnosticReport?.itemObss || []),
        }
      };
    }
    return item;
  }

  sortListLabTestOther = (listRequestOther) => {
    const newListRequestOther = listRequestOther?.map((request) => {
      return {
        ...request,
        labTestItems: this.sortConceptsByViewIndex(request?.labTestItems)
      }
    }) || []
    newListRequestOther.sort((a, b) => a?.requestForm?.viewIndex - b?.requestForm?.viewIndex)
    return newListRequestOther
  }

  getItemObsFromRequestFormConcepts = (requestForm, itemObss) => {
    // if (requestForm?.concepts?.length === itemObss?.length) {
    //   let newList = [...itemObss]
    //   this.sortConceptsByViewIndex(newList);
    //   // this.sortConceptsByName(newList, "item");
    //   return newList;
    // }
    let newList = requestForm?.concepts?.map((item) => {
      if (itemObss?.length === 0) {
        let ret = {
          item: item.concept,
          viewIndex: item?.viewIndex,
        };

        if (requestForm?.isThreshold && item?.concept?.conceptAnswer2s?.length > 0) {
          ret = this.handleDefaultThreshold(ret, item?.concept?.conceptAnswer2s);
        }
        return ret;
      }
      let obs = itemObss?.find(e => (e?.item?.id === item?.concept?.id) && !e?.isAddConcept) || null;
      if (obs) {
        return obs
      } else {
        let ret = {
          item: item.concept,
          viewIndex: item?.viewIndex,
        };
        if (requestForm?.isThreshold && item?.concept?.conceptAnswer2s?.length > 0) {
          ret = this.handleDefaultThreshold(ret, item?.concept?.conceptAnswer2s);
        }
        return ret;
      }
    }, [])
    // console.log("🚀 ~ newList", newList)
    // console.log("🚀 ~ itemObss", itemObss)
    if (!newList?.some(e => e?.isAddConcept) && itemObss?.some(e => e?.isAddConcept)) {
      const listAddConcept = itemObss.filter(e => e?.isAddConcept);
      newList = newList.concat(listAddConcept)
    }
    this.sortConceptsByViewIndex(newList);
    return newList;
  }

  handleDefaultThreshold = (obsItem, answers) => {
    let ret = { ...obsItem }
    switch (ret?.item?.datatype2) {
      case LocalConstants.DATATYPE_NUMERIC: {
        ret = {
          ...ret,
          valueNumeric: answers?.[0]?.name || ""
        }
        break;
      }
      default: {
        ret = {
          ...ret,
          valueText: answers?.[0]?.name || ""
        }
        break;
      }
    }
    return ret;
  }

  sortConceptsByViewIndex = (concepts) => {
    return concepts?.sort((a, b) => a?.viewIndex - b?.viewIndex)
  }
  // sortConceptsByName = (concepts, conceptKey) => {
  //   return concepts?.sort((a, b) => a?.[conceptKey]?.name?.localeCompare(b?.[conceptKey]?.name))
  // }

  handleOpenNotificationPopup = (notiDetail) => {
    this.shouldOpenNotificationPopup = true;
    this.notificationDetail = notiDetail;
  }

  handleGetAndOpenNotificationPopup = (patientId) => {
    this.listNotificationDetail = [];
    this.currentPatientNotificationId = patientId;
    pagingNotificationPatients({
      pageIndex: 1,
      pageSize: 99,
      active: true,
      patientId,
      patientType: LocalConstants.PATIENT_TYPE_DRUG_RESISTANT_TB
    }).then(({ data }) => {
      runInAction(() => {
        this.shouldOpenNotificationPopup = true;
        //lọc bỏ chờ tiếp nhận nếu là tài khoản đơn vị hoặc khoa phòng đăng nhập
        //update lọc bỏ các thông báo khác khi là tài khoản đơn vị hoặc khoa phòng chuyển đến
        //khi trạng thái đang chờ tiếp nhận
        let newList = [...data?.content];
        if ((localStorageService.isOrg() || localStorageService.isDepartment())) {
          //nếu là đơn vị chuyển đến chưa tiếp nhận thì chỉ hiện thị thông báo tiếp nhận
          const findTestType1 = data?.content?.find(f => f?.type === 1);
          if (findTestType1) {
            if (localStorageService.getCurrentOrg()?.id === findTestType1?.orgTo) {
              newList = [findTestType1]
            }
            //nếu là đơn vị chuyển đi thì không hiện thông báo chuyển đi
            //03/01/2023 cập nhật đơn vị chuyển đi hiện thông báo chuyển đi nhưng không cho click vào
            else {
              newList = newList?.map((item) => {
                if (item?.type === 1) {
                  return {
                    ...item,
                    disabled: true
                  }
                }
                return item
              })
            }
          }
        }

        //nếu tài khoản tỉnh đăng nhập cần check quyền tiếp nhận trong tỉnh và tỉnh khác
        if (localStorageService.isProvince()) {
          const findTestType1 = data?.content?.find(f => f?.type === 1);
          if (findTestType1) {
            if (localStorageService.getAdminUnit()?.id === findTestType1?.provinceFrom) {
              newList = newList?.map((item) => {
                if (item?.type === 1) {
                  return {
                    ...item,
                    disabled: true
                  }
                }
                return item
              })
            } else {
              newList = [findTestType1]
            }
          }
        }

        this.listNotificationDetail = newList
      })
      // console.log(data);
      // this.notificationDetail = notiDetail;
    })
  }

  setShouldOpenNotificationPopup = state => {
    this.shouldOpenNotificationPopup = state;
  }

  setShouldOpenNotificationLabTestResultPopup = state => {
    this.shouldOpenNotificationLabTestResultPopup = state;
    if (!state) {
      this.setDetailNotificationEncounterId(null);
      this.handleSelectNotificationLabTestResult(null);
    }
  }

  closeNotificationPopupForPendingTestList = () => {
    this.shouldOpenNotificationLabTestResultPopup = false;
    this.setDetailNotificationEncounterId(null);
    this.handleSelectNotificationLabTestResult(null);
  }

  getNotificationLabTestResult = async (requestId) => {
    if (requestId != null) {
      try {
        let res = await getLabTestWaitingResult(requestId);
        this.handleSelectNotificationLabTestResult(res.data);
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectNotificationLabTestResult(null);
    }
  };

  getNotificationLabTestHIVResult = async (requestId) => {
    if (requestId != null) {
      try {
        let res = await getEtbServiceItemObsHiv(requestId);
        this.handleSelectNotificationLabTestResult(res.data);
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectNotificationLabTestResult(null);
    }
  };

  handleSelectNotificationLabTestResult = (obj) => {
    this.selectedNotificationLabTestResult = obj;
  }

  handleOpenNotificationLabTestResultPopup = (detail) => {
    if (detail.requestId) {
      if (detail?.requestFormName?.toUpperCase()?.trim() === "HIV") {
        this.getNotificationLabTestHIVResult(detail?.requestId).then(() => {
          this.setDetailNotificationEncounterId(detail.encounterId)
          this.setShouldOpenNotificationLabTestResultPopup(true)
          this.setShouldOpenNotificationPopup(false)
        })
      } else {
        this.getNotificationLabTestResult(detail?.requestId).then(() => {
          this.setDetailNotificationEncounterId(detail.encounterId)
          this.setShouldOpenNotificationLabTestResultPopup(true)
          this.setShouldOpenNotificationPopup(false)
        })
      }
    }
  }

  setDetailNotificationEncounterId = id => {
    this.detailNotificationEncounterId = id
  }

  setShouldOpenAdsmResultPopup = state => {
    this.shouldOpenAdsmResultPopup = state
    if (!state) {
      this.selectedNotificationADSM = null;
    }
  }

  handleOpenNotificationAdsmResultPopup = () => {
    // this.selectedNotificationADSM
    if (this.currentPatientNotificationId) {
      incompletePatientAdsm(this.currentPatientNotificationId).then(({ data }) => {
        runInAction(() => {
          this.selectedNotificationADSM = data;
        })
        this.setShouldOpenAdsmResultPopup(true)
        this.setShouldOpenNotificationPopup(false)
      });
    }
  }

  setShouldOpenNotificationConfirmTransferPopup = state => {
    this.shouldOpenNotificationConfirmTransferPopup = state
    if (!state) {
      this.selectedNotificationConfirmTransferItem = null;
    }
  }

  handleOpenNotificationConfirmTransferPopup = (encounterId) => {
    // this.selectedNotificationADSM
    if (encounterId) {
      patientTransferOutByEncounter(encounterId).then(({ data }) => {
        runInAction(() => {
          this.selectedNotificationConfirmTransferItem = data;
        })
        this.setShouldOpenNotificationConfirmTransferPopup(true)
        this.setShouldOpenNotificationPopup(false)
      });
    }
  }

  handleSubmitNotificationConfirmTransferPopup = (item, formHelper) => {
    const obj = {
      ...this.selectedNotificationConfirmTransferItem,
      transferDate: item?.transferDate,
      receivedDate: item?.receivedDate,
    };
    if (!moment(obj?.receivedDate).isValid()) {
      toast.warn(i18n.t("toast.receptDate"));
      formHelper.setSubmitting(false);
      return;
    }
    if (obj?.transferDate && obj?.receivedDate) {
      if (moment(obj?.transferDate)
        .isAfter(moment(obj?.receivedDate), "d")) {
        toast.warn(i18n.t("toast.receptDateVsTranferDate"));
        formHelper.setSubmitting(false);
        return
      }
    }
    return confirmTransferEtb(obj).then((res) => {
      if (res?.data?.code === "-1") {
        toast.warn(i18n.t("toast.receivedByOther"));
        return res;
      }
      toast.success(i18n.t("toast.successReceived"));
    }).catch((error) => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }).finally(() => {
      this.updateCountSaveEncounter()
    })
  }

  updateCountSaveEncounter = () => this.countSaveEncounter++;

  //ds bệnh nhân từ thông báo
  updatePageDataPatientFromNotification = () => {
    this.loadingInitial = true;

    let newSearchObj = this.getNewSearchObject()

    patientManagementNotificationPatient(newSearchObj).then((res) => {
      runInAction(() => {
        this.patientList = res.data?.content;
        this.totalElements = res.data?.totalElements;
        this.totalPages = res.data?.totalPages;
      });
      this.setLoadingInitial(false);
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    })
  };

  //ds chuyển đến, chuyển đi
  getPagePatientMoveInOrOut = () => {
    this.loadingInitial = true;

    let newSearchObj = this.getNewSearchObject()

    getPagePatientMoveInOrOut(newSearchObj).then((res) => {
      runInAction(() => {
        this.patientList = res.data?.patients?.content;
        this.totalElements = res.data?.patients?.totalElements;
        this.totalPages = res.data?.patients?.totalPages;
      });
      this.setLoadingInitial(false);
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    })
  };

  exportCurrentPatientList = () => {
    let newSearchObj = this.getNewSearchObject()

    exportCurrentPatientList(newSearchObj).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "TONG-HOP-DANH-SACH-BENH-NHAN-"
        + moment(new Date()).format("DDMMYYYY-HHmm")
        + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    })
  }

  exportPatientIndexList = () => {
    let newSearchObj = this.getNewSearchObject();
    const exportSearchObject = {
      pageIndex: 1, 
      pageSize: 10000, 
      patientType: null, 
      fromDate: newSearchObj?.fromDate, 
      toDate: newSearchObj.toDate, 
      watchBy: LocalConstants.PatientSearchWatchBy[2]?.value,
      currentProvinceId: this.searchObject?.currentProvinceExport?.id,
      currentDistrictId: this.searchObject?.currentDistrictExport?.id,
      currentWardId: this.searchObject?.currentWardExport?.id,
      treatmentByPatientType: true,
      isIncludingPatientsWhoHaveBeenTreated: true,
      choicePatientType: 3,
    }
    exportPatientIndexList(exportSearchObject).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        "DANH-SACH-BENH-NHAN-DINH-HUONG"
        + moment(new Date()).format("DDMMYYYY-HHmm")
        + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    })
  }

  getNewSearchObject = () => {
    return {
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      keyword: this.searchObject.keyword,
      idNumber: this.searchObject.idNumber,
      gender: this.searchObject.gender,
      professionId: this.searchObject.profession?.id,
      nationalityId: this.searchObject.nationality?.id,
      religionId: this.searchObject.religion?.id,
      ethnicsId: this.searchObject.ethnics?.id,
      orgId: this.searchObject.currentUnit?.id,
      regionId: this.searchObject.currentRegion?.id,
      provinceId: this.searchObject.currentProvince?.id,
      districtId: this.searchObject.currentDistrict?.id,
      wardId: this.searchObject.currentWard?.id,
      patientTransfer: this.searchObject.patientTransfer,
      typeOfPatient: this.searchObject.typeOfPatient,
      transferStatus: this.searchObject.transferStatus,
      patientType: 3,
      sortByDateEncounterDesc: this.searchObject.sortByDateEncounterDesc,
      registerType: this.searchObject.registerType,
      patientName: this.searchObject.patientName,
      phoneNumber: this.searchObject.phoneNumber,
      medicalInsurance: this.searchObject.medicalInsurance,
      fromAge: this.searchObject.fromAge,
      toAge: this.searchObject.toAge,
      fromDate: this.searchObject.fromDate,
      toDate: this.searchObject.toDate,
      watchBy: this.searchObject.watchBy,
      typeNotification: this.searchObject.typeNotification,
      patientCode: this.searchObject.patientCode,
      registerNo: this.searchObject.registerNo,
      medicationId: this.searchObject?.medication?.id,
      isDotsThuoc: this.isDotsThuoc,
      bacterialEvidence: this.searchObject?.bacterialEvidence,
      sortByRegisterDate: this.searchObject?.sortByRegisterDate, //order by theo ngày đăng ký điều trị
      sortByPatientCode: this.searchObject?.sortByPatientCode, //order by theo mã BNQL
      sortByPatientName: this.searchObject?.sortByPatientName, //order by theo tên BN
      currentProvinceId: this.searchObject?.provinceAddress?.id,
      currentDistrictId: this.searchObject?.districtAddress?.id, //huyện theo địa chỉ
      currentWardId: this.searchObject?.wardAddress?.id, //xã theo địa chỉ
    };
  }

  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      //set các trường sort khác = null
      sortByRegisterDate: null, //order by theo ngày đăng ký điều trị
      sortByPatientCode: null, //order by theo mã BNQL
      sortByPatientName: null, //order by theo tên BN
      sortByDateEncounterDesc: null,
      ...item,
    };
    this.updatePageData();
  }

  setEncounterTabValue = value => {
    this.encounterTabValue = value
  }

  //reset biến searchObject khi rời đi
  resetSearchObject = () => {
    this.page = 1
    this.rowsPerPage = 10
    this.searchObject = { ...searchObjectInitialValue }
    this.setIsDotsThuoc(false);

    if (this.patientListSearchTimeout) {
      clearTimeout(this.patientListSearchTimeout)
    }
  }

  handleBackupSearchObject = () => {
    this.backupSearchObject = {
      page: this.page,
      rowsPerPage: this.rowsPerPage,
      searchObject: this.searchObject,
      isDotsThuoc: this.isDotsThuoc,
    }
  }

  getBackupSearchObject = () => {
    this.page = this.backupSearchObject?.page
    this.rowsPerPage = this.backupSearchObject?.rowsPerPage
    this.searchObject = this.backupSearchObject?.searchObject
    this.isDotsThuoc = this.backupSearchObject?.isDotsThuoc
    this.isBackupSearchObject = false;
  }

  setIsBackupSearchObject = (state) => this.isBackupSearchObject = state;

  setDefaultM2LabTestDate = (value, name) => {
    this.defaultM2LabTestDate = value
    this.defaultM2LabTestDateName = name
  }
  //ghi nhớ lại đơn vị trong xn tổng quát, nếu có
  handleMemoUnitOtherTest = (encounter) => {
    if (encounter?.orderTest?.listRequestOther?.length > 0) {
      const currentMemoList = localStorageService.getItem(LocalConstants.LOCAL_STORAGE_MEMO_UNIT_KEY)
        ? JSON.parse(localStorageService.getItem(LocalConstants.LOCAL_STORAGE_MEMO_UNIT_KEY))
        : [];

      const newMemoList = encounter.orderTest.listRequestOther.reduce((acc, currentValue) => {
        if (currentValue?.labTestItems?.length > 0) {
          const newItemsList = currentValue.labTestItems.reduce((acc1, currentValue1) => {
            if (currentValue1?.unitName) {
              return [...acc1, { conceptId: currentValue1?.concept?.id, unitName: currentValue1?.unitName }]
            }
            return acc1
          }, [])
          if (newItemsList?.length > 0) {
            // return [...new Set([...acc ,...newItemsList])]
            return lodash.uniqBy([...newItemsList, ...acc], "conceptId")
          }
          return acc
        }
        return acc
      }, currentMemoList)
      localStorageService.setItem(LocalConstants.LOCAL_STORAGE_MEMO_UNIT_KEY, JSON.stringify(newMemoList))
    }
  }

  //thẻ nhắc trong chi tiết bn

  getPatientReminderCardList = (patientId) => {
    this.patientReminderCardList = [];
    pagingNotificationPatients({
      pageIndex: 1,
      pageSize: 99,
      active: true,
      patientId,
      patientType: LocalConstants.PATIENT_TYPE_DRUG_RESISTANT_TB
    }).then(({ data }) => {
      runInAction(() => {
        // this.shouldOpenNotificationPopup = true;
        //lọc bỏ cái chờ tiếp nhận nếu là tài khoản đơn vị đăng nhập
        let newList = [...data?.content].reduce((acc, test) => {
          if (test?.type === 1 && localStorageService.isOrg()) {
            if (localStorageService.getCurrentOrg()?.id === test?.orgTo) {
              return [...acc, test];
            } else {
              return acc
            }
          }
          return [...acc, test];
        }, []);

        this.patientReminderCardList = newList
      })
    })
  }

  setShouldCheckTypeResistance = state => this.shouldCheckTypeResistance = state;

  setIsDotsThuoc = state => this.isDotsThuoc = state;
  setOpenDuplicationPatientPopup = (state) => this.openDuplicationPatientPopup = state;

  handleAcceptPatientFromOther = async () => {
    try {
      const res = await acceptPatientFromOther(this.selectedPatient)
      if (res?.data) {
        switch (res?.data?.code) {
          case "-1": {
            toast.error("Không thể tiếp nhận bệnh nhân vì bệnh nhân chưa có sổ khám nào.")
            break;
          }
          
          default: {
            toast.success("Đã tiếp nhận BN thành công");
            this.getEtbAll({
              patientId: res?.data?.id,
              typeBook: LocalConstants.TypeBook?.[0]?.value,
            })
            break;
          }
        }
      }
    } catch (error) {
      console.error(error);
      toast.warning(i18n.t("toast.error"));
    }
  }

  handleNotAcceptPatientFromOther = async () => {
    try {
      const res = await notAcceptPatientFromOther(this.selectedPatient)
      if (res?.data) {
        toast.success("Đã từ chối tiếp nhận BN");
        this.getEtbAll({
          patientId: res?.data?.id,
          typeBook: LocalConstants.TypeBook?.[0]?.value,
        })
      }
    } catch (error) {
      console.error(error);
      toast.warning(i18n.t("toast.error"));
    }
  }

}
